<div class="table-container">
  @if (data) {
    <p-table [value]="data.data" [scrollable]="true" class="table" class="p-datatable-striped">
      <ng-template pTemplate="header">
        <tr>
          <th>
            <button type="button" class="table__sort" (click)="sortChange.emit('order_number')">
              NRO. PEDIDO <i [class]="sortIcon('order_number')"></i>
            </button>
          </th>
          <th>
            <button type="button" class="table__sort" (click)="sortChange.emit('name')">
              NOME <i [class]="sortIcon('name')"></i>
            </button>
          </th>
          <th>INGRESSOS</th>
          <th>
            <button type="button" class="table__sort" (click)="sortChange.emit('email')">
              E-MAIL <i [class]="sortIcon('email')"></i>
            </button>
          </th>
          <th>TELEFONE</th>
          <th>CANAL</th>
          <th>
            <button type="button" class="table__sort" (click)="sortChange.emit('total_amount')">
              VALOR DA VENDA <i [class]="sortIcon('total_amount')"></i>
            </button>
          </th>
          <th>
            <button type="button" class="table__sort" (click)="sortChange.emit('payment_method')">
              MEIO DE PAGAMENTO <i [class]="sortIcon('payment_method')"></i>
            </button>
          </th>
          <th>
            <button type="button" class="table__sort" (click)="sortChange.emit('date_time_order')">
              DATA E HORA <i [class]="sortIcon('date_time_order')"></i>
            </button>
          </th>
          <th>
            <button type="button" class="table__sort" (click)="sortChange.emit('status')">
              STATUS <i [class]="sortIcon('status')"></i>
            </button>
          </th>
          <th>DETALHAR</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-participant let-rowIndex="rowIndex as number">
        <tr>
          <td>#{{ participant.order_number }}</td>
          <td>{{ customerName(participant) }}</td>
          <td>{{ participant.tickets_quantity }}</td>
          <td>{{ customerEmail(participant) }}</td>
          <td>{{ customerTelephone(participant) }}</td>
          <td>{{ participant.sales_channel ? (participant.sales_channel | salesChannel) : "Não informado" }}</td>
          <td>{{ participant.total_amount | currency: "BRL" }}</td>
          <td>{{ participant.payment_method | paymentMethod }}</td>
          <td>{{ participant.date_time_order | date: "dd/MM/yy HH:mm" }}</td>

          <td>
            <span class="table__status table__status--{{ (participant.payment_status | paymentStatus).toLowerCase() }}">
              {{ participant.payment_status | paymentStatus }}
            </span>
          </td>

          <td>
            <button mat-icon-button aria-label="Detalhar pedido" (click)="detailOrderClick.emit(participant)">
              <mat-icon>visibility</mat-icon>
            </button>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="11" class="table__empty">Nenhum pedido encontrado para este filtro.</td>
        </tr>
      </ng-template>
    </p-table>
    <p-paginator
      (onPageChange)="pageChange.emit($event)"
      [first]="first"
      [rows]="rows"
      [totalRecords]="data.meta.total_count || 0"
      [showCurrentPageReport]="false"
      [showPageLinks]="false"
      [showJumpToPageDropdown]="false"
      [rowsPerPageOptions]="[10, 20, 30]"
      currentPageReportTemplate="Mostrando {first} até {last} de {totalRecords}" />
  } @else {
    <p-skeleton height="350px" />
  }
</div>
